'use strict';

import { Entity } from '../Entity';

export class UserDocument extends Entity {
  protected docId;
  protected docPlatform;
  protected docRoot;
  protected docPath;
  protected docFilename;
  protected docSystemName;
  protected docType;
  protected docScope;
  protected docSize;
  protected docDate;

  protected user;
  protected individual;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.docId = data.docId;
    this.docPlatform = data.docPlatform;
    this.docRoot = data.docRoot;
    this.docPath = data.docPath;
    this.docFilename = data.docFilename;
    this.docSystemName = data.docSystemName;
    this.docType = data.docType;
    this.docScope = data.docScope;
    this.docSize = data.docSize;

    if (data.docDate) {
      const docDate = data.docDate.date.split(' ')[0].split('-');
      this.docDate = docDate[1] + '/' + docDate[2] + '/' + docDate[0];
    }
  }

  public getDocId() {
    return this.docId;
  }

  public getDocPlatform() {
    return this.docPlatform;
  }

  public getDocRoot() {
    return this.docRoot;
  }

  public getDocPath() {
    return this.docPath;
  }

  public getDocFilename() {
    return this.docFilename;
  }

  public getDocSystemName() {
    return this.docSystemName;
  }

  public getDocType() {
    return this.docType;
  }

  public getDocScope() {
    return this.docScope;
  }

  public getDocSize() {
    return this.docSize;
  }

  public getDocDate() {
    return this.docDate;
  }
}
